<template>
  <b-row>
    <b-col v-for="(docs, index) in docForRender" v-bind:key="index" sm="12">
      <div v-if="docs.url" class="mb-2">
        <b-link target="_blank" :to="{name: 'อัพเดทบริษัท', params: {companyId:docs._id}}">{{ docs.name }}</b-link>
      </div>
      <div v-else class="text-muted mb-2">{{ docs.name }}</div>
      <b-row>
        <b-col v-for="doc in docs.data" v-bind:key="doc._id" sm="12">
          <b-card bg-variant="logisty-file-card">
            <b-row>
              <b-col sm="6">
                <div>
                  <b>{{ doc.fileName }}</b>
                  <span style="display: none;" :id="'spinner-' + doc._id" class="ml-2">
                    <b-spinner small label="Small Spinner"></b-spinner>
                  </span>
                </div>
              </b-col>
              <b-col sm="6">
                <span class="float-right">
                  <div class="file-list-icon">
                    <i
                      class="fa fa-cloud-download fa-2x"
                      aria-hidden="true"
                      @click="download(doc._id, doc.fileName)"
                    ></i>
                  </div>
                </span>
                <span class="float-right mr-4">
                  <div class="file-list-icon">
                    <i
                      v-if="!preventDelete"
                      class="fa fa-trash fa-2x"
                      aria-hidden="true"
                      @click="deleteDoc(doc._id)"
                    ></i>
                  </div>
                </span>
              </b-col>
            </b-row>
            <span class="logisty-custom-invalid-feedbace">เมื่อ {{ $moment(doc.createdAt).format('LLL') }}</span>
          </b-card>
        </b-col>
      </b-row>
    </b-col>
    <b-col v-if="docs && docs.length <= 0">
      <p>ยังไม่มีเอกสาร</p>
    </b-col>
  </b-row>
</template>

<script>
import HttpDoc from '../services/http/File'

export default {
  name: 'FileList',
  props: {
    docType: {
      default: null,
      type: String
    },
    preventDelete: {
      default: true,
      type: Boolean
    },
    refId: {
      default: null,
      type: String
    },
    docClass: {
      default: 'all',
      type: String
    }
  },
  data () {
    return {
      mainProps: { class: 'w-50' },
      docs: [],
      modalImgData: '',
      modalImgId: '',
      nameList: [],
      docForRender: []
    }
  },
  async mounted () {
    this.init()
    Window.Event.$on('reloadFile-' + this.docType, this.init)
  },
  beforeDestroy () {
    Window.Event.$off('reloadFile-' + this.docType)
  },
  methods: {
    async init () {
      var httpDoc = new HttpDoc(this.docType, this.refId)
      var docResponse = await httpDoc.getAllDoc()
      if (docResponse.code === 1) {
        this.docs = docResponse.data
        // filter docClass
        if (this.docClass == 'request') {
          this.docs = this.docs.filter((x) => {
            return x.type == 'request'
          })
        } else if (this.docClass == 'response') {
          this.docs = this.docs.filter((x) => {
            return x.type == 'response'
          })
        }
        this.nameList = [...new Set(this.docs.map(x => x.company.name))]
        this.link = [...new Set(this.docs.map(x => x.company.profileUrl))]
        let companyId = [...new Set(this.docs.map(x => x.company._id))]

        var docForRender = []
        for (var i = 0; i < this.nameList.length; i++) {
          var data = []

          for (var j = 0; j < this.docs.length; j++) {
            if (this.docs[j].company.name == this.nameList[i]) {
              data.push(this.docs[j])
            }
          }

          docForRender.push(
            {
              _id: companyId[i],
              name: this.nameList[i],
              url: this.link[i],
              data: data
            }
          )
        }

        this.docForRender = docForRender
        console.log(docForRender)
      } else if (docResponse.code === 12008) {

      } else {
        alert('โปรดติดต่อผู้ดูแลระบบ')
      }
    },
    async deleteDoc (docId) {
      if (!confirm('ต้องการลบหรือไม่')) {
        return
      }
      var httpDoc = new HttpDoc(this.docType, this.refId)
      var spinner = document.getElementById('spinner-' + docId)
      spinner.setAttribute('style', 'display: inline;')
      var deleteResult = await httpDoc.deleteDoc(docId)
      if (deleteResult.code == 1) {
        this.init()
      } else {
        spinner.setAttribute('style', 'display: none;')
      }
    },
    async download (docId, fileName) {
      var httpDoc = new HttpDoc(this.docType, this.refId)
      try {
        var file = await httpDoc.downloadFile(docId)
      } catch (error) {
        console.log(error)
        alert('ไม่พบเอกสาร')
        return
      }
      var fileURL = URL.createObjectURL(file)
      // window.open(fileURL, '')

      var fileLink = document.createElement('a')

      fileLink.href = fileURL
      fileLink.setAttribute('download', fileName)
      document.body.appendChild(fileLink)

      fileLink.click()
    }
  }
}
</script>
